{
  "Repo": "https://lba-consulting@dev.azure.com/lba-consulting/Abercrombie%20and%20Kent/_git/AK%20Frontend%20Reservation",
  "LastCommitHash": "270fa104e85801b09eefbe370bf93938116ee132",
  "LastCommitMessage": "Merge branch uat_price-setup-changes into dev-update-version19",
  "LastCommitAuthor": "roberto.dipiano",
  "LastCommitTime": "Thu Nov 5 11:11:15 2026 +0100",
  "VersionNumber": "22045"
}